export default __webpack_public_path__ + "static/media/key2.60aab6bc.png";